/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface OrderCancelReasonChoiceReadAttributes
 */
export interface OrderCancelReasonChoiceReadAttributes {
    /**
     * 
     * @type {Date}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    code: OrderCancelReasonChoiceReadAttributesCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderCancelReasonChoiceReadAttributes
     */
    updatedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum OrderCancelReasonChoiceReadAttributesCodeEnum {
    AlternativeDatesDenied = 'alternative-dates-denied',
    CapacityGuestRooms = 'capacity-guest-rooms',
    CapacityMeetingRooms = 'capacity-meeting-rooms',
    ContractedAnotherHotel = 'contracted-another-hotel',
    DestinationChange = 'destination-change',
    Intermediary = 'intermediary',
    Others = 'others',
    Rates = 'rates'
}

